module.exports = __webpack_public_path__ + "img/snacks-banner-pc.1dd24276.jpg";